import { Box, Stack, useTheme } from '@chakra-ui/react';
import { ContentNameType, ContentType } from '~/types/content';

import { PreviewCard } from './PreviewCard';
import { PreviewItemPlaceholder } from './PreviewItemPlaceholder';
import { SelectedContentPreviewItem } from './SelectedContentPreviewItem';

interface Props {
  contentType: ContentNameType;
  error?: string;
  maxItems: number;
  minItems: number;
  onChange: (id: string) => void;
  selectedContent: ContentType[];
  title: React.ReactNode;
}

/* This is the Modal from new MP
 *
 * TODO: It is necessary to refactor this part and
 * change to typescript all Select for the all Social Media
 * and the components related with this part.
 */
export const SelectedContentPreview: React.FC<Props> = ({
  contentType,
  error = '',
  maxItems,
  minItems,
  onChange,
  selectedContent,
  title,
}) => {
  const { lineHeights } = useTheme();

  const selectedPreviewItems = selectedContent.map((content) => (
    <SelectedContentPreviewItem
      content={content}
      contentType={contentType}
      key={content.id}
      onChange={onChange}
      previewCard={<PreviewCard content={content} contentType={contentType} />}
    />
  ));

  const amountOfPlaceholderItemsToRender =
    minItems - selectedPreviewItems.length > 0
      ? minItems - selectedPreviewItems.length
      : 0;

  const placeholderItems = new Array(amountOfPlaceholderItemsToRender)
    .fill(undefined)
    .map((_, index) => (
      <PreviewItemPlaceholder contentType={contentType} key={index} />
    ));

  return (
    <Box data-testid="selected-content-preview">
      <Box>
        <Box
          as="span"
          color="primary.500"
          fontWeight="medium"
          id="selected-content-preview-title"
        >
          {title}
        </Box>

        <Box
          as="span"
          color="primary.300"
          fontSize="md"
          id="selected-content-preview-hint"
        >
          {` (minimum of ${minItems}, maximum of ${maxItems})`}
        </Box>
      </Box>

      <Stack
        aria-describedby="selected-content-preview-hint"
        aria-labelledby="selected-content-preview-title"
        direction="row"
        paddingY={2}
      >
        {selectedPreviewItems}

        {placeholderItems}
      </Stack>

      <Box
        as="span"
        color="error.500"
        fontSize="sm"
        lineHeight="short"
        marginBottom={4}
        minHeight={`${lineHeights.short}em`}
        visibility={error ? 'visible' : 'hidden'}
      >
        {error}
      </Box>
    </Box>
  );
};
